// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28vf-","footer":"styles_footer__2U7gE"};